// Logged-in app page: post captions (routes/Captions.tsx). Keep keys in sync with en/appCaptions.ts.
// Sesja 10 (artboard 16): jedno zdanie kontekstu (blok „Gdzie to trafia” zniknął razem z nazwą
// wewnętrznego komponentu - G6-library-13), zasady jedną linią przy polu, kategorie filtrują
// także własne paczki (decyzja 3), pusty stan z akcją tworzenia (G6-library-14).
//
// PACZKA 34 (MAPA sesji 34 po R2). Licznik opisu ma teraz format „{n}/150”, a hashtagi stoją
// obok jako osobna liczba — `item.chars_*` przestało być wołane, bo liczba bez słowa jest
// krótsza i tak samo czytelna. Reguła przeniosła się do tekstu zastępczego pola (decyzja 3),
// a zdanie `library.invalid` zostaje dla reguł, których licznik nie pokazuje.
export const appCaptions = {
  head: {
    title: 'Opisy',
  },
  intro: {
    body: 'Teksty pod posty.',
  },
  // OKNO „ZMIENNE” (reguła 33, runda B-R3). Wyłącznie zmienne, które parser
  // podstawia dzisiaj (`lib/textTemplates.ts`). Przykład to WYNIK podstawienia,
  // nie zapis zmiennej: wiersz ma pokazać, co zobaczy widz, nie powtórzyć nazwę.
  // Grupa „Losowe” czeka na `{random_emoji}` z reguły 33 — nagłówek bez wierszy
  // się nie renderuje.
  variables: {
    label: 'Zmienne',
    intro: 'Wartości wpisujesz przy planowaniu paczki do publikacji.',
    fixed: 'Stałe',
    random: 'Losowe',
    artist: 'nazwa artysty',
    artistExample: 'Nocna Zmiana, nowy numer',
    title: 'tytuł utworu',
    titleExample: 'Mokry asfalt już jest',
    nick: 'konto, na które idzie post',
    nickExample: '@domi.music',
    timestamp: 'moment utworu',
    timestampExample: 'wejście basu w 0:31',
    // Nazwy dla czytnika ekranu; {variable} podstawia komponent.
    insert: 'Wstaw {variable}',
    copy: 'Kopiuj {variable}',
    copied: 'Skopiowano',
    copyFailed: 'Nie udało się skopiować.',
    close: 'Zamknij',
  },
  list: {
    heading: 'Paczki',
    collection_one: 'paczka',
    collection_few: 'paczki',
    collection_many: 'paczek',
    captions_one: 'opis',
    captions_few: 'opisy',
    captions_many: 'opisów',
    newCollection: 'Nowa paczka',
  },
  form: {
    name: 'Nazwa',
    namePlaceholder: 'np. Opisy na premierę',
    create: 'Utwórz',
    cancel: 'Anuluj',
  },
  // Trzy limity w JEDNEJ linii przy polu (G6-library-13). Reguła o liczbie zdań nie mieści
  // się w linii na 390 - egzekwuje ją lint przy zapisie, nie ten podpis.
  rules: {
    line: 'Do 150 znaków · maksymalnie 3 hashtagi · bez obietnic o skutku po publikacji',
    length: 'Do 150 znaków.',
    hashtags: 'Maksymalnie 3 hashtagi.',
  },
  state: {
    loadError: 'Nie udało się wczytać paczki.',
    emptyTitle: 'Brak paczek opisów',
    emptyBody: 'Zacznij od gotowej paczki EDIMI albo stwórz własną - opisy będą do wyboru przy publikacji edita.',
  },
  coll: {
    own: 'własna',
    more: 'Więcej akcji: {name}',
    expand: 'Rozwiń paczkę {name}',
    collapse: 'Zwiń paczkę {name}',
    deleteCollectionTitle: 'Usuń paczkę',
    deleteAsk: 'Usunąć paczkę?',
    deleteRow: 'Opisy',
    emptyItems: 'Brak opisów',
    deleteItemTitle: 'Usuń opis',
    deleteItemLabel: 'Usuń opis „{text}”',
    deleteItemAsk: 'Usunąć opis „{text}”?',
    rowMenu: 'Opis',
    addHeading: 'Dodaj opis',
    oneEach: 'Jeden opis na linię',
    add: 'Dodaj',
    addN: 'Dodaj {count} opisów',
    addN_one: 'Dodaj {count} opis',
    addN_few: 'Dodaj {count} opisy',
    addN_many: 'Dodaj {count} opisów',
    pasteCount: '{count} opisów do dodania',
    pasteCount_one: '{count} opis do dodania',
    pasteCount_few: '{count} opisy do dodania',
    pasteCount_many: '{count} opisów do dodania',
  },
  system: {
    heading: 'Paczki EDIMI',
    countAll: '{n} · gotowe do użycia',
    readOnly: 'tylko do odczytu',
    copyToMine: 'Kopiuj do moich',
    copyDone: 'Skopiowano do moich paczek.',
    andMore: '…i {count} kolejnych',
  },
  library: {
    mine: 'Moje',
    all: 'Wszystkie paczki',
    edimi: 'EDIMI',
    newPack: 'Nowa paczka',
    save: 'Zapisz',
    rename: 'Zmień nazwę',
    openPack: 'Otwórz {name}',
    selectPack: 'Zaznacz paczkę „{name}”',
    deletePack: 'Usuń paczkę',
    deletePacksAsk: 'Usunąć {count} paczek?',
    deletePacksAsk_one: 'Usunąć paczkę?',
    deletePacksAsk_few: 'Usunąć {count} paczki?',
    deletePacksAsk_many: 'Usunąć {count} paczek?',
    deletePacksDo: 'Usuń {count} paczek',
    deletePacksDo_one: 'Usuń paczkę',
    deletePacksDo_few: 'Usuń {count} paczki',
    deletePacksDo_many: 'Usuń {count} paczek',
    selected: 'zaznaczone',
    // Czasownik, nie samo słowo zbioru: obok stoi pigułka zakresu „Wszystkie”,
    // a te dwa przyciski robią rzeczy przeciwne (przegląd D).
    selectAll: 'Zaznacz wszystkie',
    selectNone: 'Żadna',
    emptyAll: 'Brak paczek opisów',
    emptyAllBody: 'Utwórz własną paczkę albo otwórz EDIMI, żeby zacząć.',
    emptyEdimi: 'Brak paczek EDIMI',
    emptyEdimiBody: 'Gdy paczki EDIMI będą dostępne w tym języku, pojawią się tutaj.',
    choosePackPrompt: 'Wybierz paczkę',
    choosePackPromptBody: 'Opisy z wybranej paczki pojawią się tutaj.',
    actionFailed: 'Nie udało się wykonać operacji.',
    back: 'Opisy',
    selectItem: 'Zaznacz opis „{text}”',
    moveItems: 'Przenieś do innej paczki',
    copyItems: 'Kopiuj do innej paczki',
    deleteItemsAsk: 'Usunąć {count} opisów?',
    deleteItemsAsk_one: 'Usunąć opis?',
    deleteItemsAsk_few: 'Usunąć {count} opisy?',
    deleteItemsAsk_many: 'Usunąć {count} opisów?',
    deleteItemsDo: 'Usuń {count} opisów',
    deleteItemsDo_one: 'Usuń opis',
    deleteItemsDo_few: 'Usuń {count} opisy',
    deleteItemsDo_many: 'Usuń {count} opisów',
    addRules: 'Jeden opis na linię · do 150 znaków · maksymalnie 3 hashtagi · używaj {@nick} jako zmiennej',
    targetPack: 'Paczka docelowa',
    choosePack: 'Wybierz paczkę',
    confirmMove: 'Przenieś {count} opisów',
    confirmMove_one: 'Przenieś {count} opis',
    confirmMove_few: 'Przenieś {count} opisy',
    confirmMove_many: 'Przenieś {count} opisów',
    confirmCopy: 'Kopiuj {count} opisów',
    confirmCopy_one: 'Kopiuj {count} opis',
    confirmCopy_few: 'Kopiuj {count} opisy',
    confirmCopy_many: 'Kopiuj {count} opisów',
    noTarget: 'Nie masz innej własnej paczki.',
    noTargetBody: 'Najpierw utwórz inną pustą paczkę opisów.',
    errorConflict: 'W paczce docelowej jest inny opis pod tym samym miejscem.',
    errorChanged: 'Zawartość paczki zmieniła się w trakcie operacji.',
    errorMissing: 'Jednego z opisów albo paczki już nie ma.',
    errorSame: 'Wybierz inną paczkę docelową.',
    errorGeneric: 'Nie udało się wykonać operacji.',
    invalid: 'Popraw opis przed dodaniem',
    retry: 'Spróbuj ponownie',
    newPackFailed: 'Nie udało się utworzyć paczki.',
    // Paczka 34: ciche akcje półki, pasek zaznaczenia, pigułka planu w oknie kasowania.
    select: 'Zaznacz',
    selectedCount: 'Zaznaczone: {count}',
    deleteCount: 'Usuń ({count})',
    moveShort: 'Przenieś',
    copyShort: 'Kopiuj',
    loadFailed: 'Nie udało się wczytać paczek opisów.',
    inPlan: 'w planie publikacji',
    toastAdded: 'Dodano {count} opisów.',
    toastAdded_one: 'Dodano {count} opis.',
    toastAdded_few: 'Dodano {count} opisy.',
    toastAdded_many: 'Dodano {count} opisów.',
    toastMoved: 'Przeniesiono {count} opisów do paczki „{name}”.',
    toastMoved_one: 'Przeniesiono {count} opis do paczki „{name}”.',
    toastMoved_few: 'Przeniesiono {count} opisy do paczki „{name}”.',
    toastMoved_many: 'Przeniesiono {count} opisów do paczki „{name}”.',
    toastCopied: 'Skopiowano {count} opisów do paczki „{name}”.',
    toastCopied_one: 'Skopiowano {count} opis do paczki „{name}”.',
    toastCopied_few: 'Skopiowano {count} opisy do paczki „{name}”.',
    toastCopied_many: 'Skopiowano {count} opisów do paczki „{name}”.',
    toastPackDeleted: 'Paczka usunięta.',
    toastPackDeleteFailed: 'Nie udało się usunąć paczki.',
  },
  item: {
    copy: 'Kopiuj opis',
    copied: 'Skopiowano opis.',
    copyFailed: 'Nie udało się skopiować opisu.',
    // Licznik: liczba znaków PO podstawieniu przykładowego nicka, łamana przez limit.
    count: '{chars}/{limit}',
    chars_one: '{count} znak',
    chars_few: '{count} znaki',
    chars_many: '{count} znaków',
    hashtags_one: '{count} hashtag',
    hashtags_few: '{count} hashtagi',
    hashtags_many: '{count} hashtagów',
    // Tytuł arkusza „⋯” wiersza opisu na 390 (runda 33-R4).
    more: 'Opis {i} z {n}',
  },
  // Runda 33-R4 (reguła 57): pole dodawania z etykietą; licznik „{n}/150” jest daną.
  field: {
    label: 'Nowy opis',
    placeholder: 'tekst posta',
  },
}
